import { FormGroup } from '@angular/forms';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';

/**
 * Returns control value of a given form
 */
export function getFormControlValue<T>(form: FormGroup): (field: string) => T {
  return (field: string): T => form.controls[field]?.value as T;
};

/**
 * Checks if validFor field is set to custom
 */
export const isValueForSetToCustom = (form: FormGroup): boolean => {
  return getFormControlValue(form)('validFor') === -1;
};

/**
 * Sets the validForCustom field value form depending on the validFor field
 * Sets it equal 1 if validFor set to custom and resets otherwise.
 */
export const adjustValidForCustom = (form: FormGroup): void => {
  const { validForCustom } = form.controls;
  if (!isValueForSetToCustom(form)) {
    return validForCustom.setValue(-1);
  }
  if (validForCustom.value < 1) {
    return validForCustom.setValue(1);
  }
};

/**
 * Returns link duration depending on validFor and validForCustom fields
 */
export const getLinkDuration = (form: FormGroup): number => {
  const validFor = getFormControlValue<number>(form)('validFor');
  const validForCustom = getFormControlValue<number>(form)('validForCustom');
  return validFor === -1 ? validForCustom : validFor;
};

/**
 * Checks is link duration correct depending on validFor and validForCustom
 */
export const isValidLinkDuration = (form: FormGroup): boolean => {
  const validFor = getFormControlValue<number>(form)('validFor');
  const validForCustom = getFormControlValue<number>(form)('validForCustom');
  return (validFor !== null && validFor > 0)
    || (validFor === -1 && validForCustom > 0);
};

/**
 * Checks is form valid
 */
export const isShareLinkExternalFormValid = (form: FormGroup): boolean => (
  isValidLinkDuration(form) &&
  getFormControlValue(form)('allowSingleDownloading') !== null
);

/**
 * Returns an Observable that emits a boolean value each time
 * the form changes its validity
 */
export const isShareLinkExternalFormValid$ = (form: FormGroup): Observable<boolean> => (
  form.valueChanges.pipe(
    startWith(null),
    map(() => isShareLinkExternalFormValid(form)),
    distinctUntilChanged(),
  )
);
